import React, { useState } from 'react';
import { X } from 'lucide-react';
import { galleryImages } from '../mock';

const GallerySection = ({ setActiveSection, activeSection }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  // ⭐ Show banner ONLY when activeSection === "gallery"
  const showBanner = activeSection === "gallery";

  return (
    <section id="gallery" className="bg-white">

      {/* ⭐ PREMIUM BANNER — SAME STYLE AS ABOUT SECTION */}
      {showBanner && (
        <div className="relative w-full h-[350px] md:h-[450px]">

          {/* Background Image */}
          <img
            src="/gallary/g7.jpg"
            alt="Gallery Banner"
            className="absolute inset-0 w-full h-full object-cover"
          />

          {/* Dark Overlay */}
          <div className="absolute inset-0 bg-black/50"></div>

          {/* ⭐ CENTER HEADING */}
          <div className="absolute inset-0 flex items-center justify-center">
            <h1 className="text-4xl md:text-6xl font-bold text-white drop-shadow-lg">
              Gallery
            </h1>
          </div>

          {/* ⭐ LEFT BOTTOM TITLE */}
          <div className="absolute bottom-0 left-0 bg-black/40 py-4 px-6">
            <h2 className="text-xl md:text-2xl font-semibold text-white">
              Gallery
            </h2>
          </div>

          {/* ⭐ RIGHT BOTTOM BREADCRUMB */}
          <div className="absolute bottom-0 right-0 bg-black/40 py-4 px-6 flex items-center gap-2 text-white">
            <button
              onClick={() => setActiveSection("home")}
              className="hover:text-amber-300 transition"
            >
              Home
            </button>
            <span>›</span>
            <span className="text-amber-300">Gallery</span>
          </div>
        </div>
      )}

      {/* ⭐ YOUR ORIGINAL CODE (NO CHANGE AT ALL) */}

      <div className="container mx-auto px-4 py-10 text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
          Our <span className="text-amber-900">Gallery</span>
        </h2>
        <p className="text-gray-600 mt-3">
          Take a visual tour of our serene spa environment
        </p>
        <div className="w-24 h-1 bg-amber-900 mx-auto mt-3"></div>
      </div>

      {/* IMAGE GRID */}
      <div className="container mx-auto px-4 pb-16 grid 
                      grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {galleryImages.map((image, index) => (
          <div
            key={index}
            className="relative overflow-hidden rounded-lg cursor-pointer group h-64"
            onClick={() => setSelectedImage(image)}
          >
            <img
              src={image}
              alt={`Gallery ${index + 1}`}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 
                            transition-all duration-300 flex items-center justify-center">
              <span className="text-white opacity-0 group-hover:opacity-100 
                                transition-opacity text-lg font-semibold">
                View
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* LIGHTBOX */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-amber-400 transition-colors"
            onClick={() => setSelectedImage(null)}
          >
            <X size={32} />
          </button>

          <img
            src={selectedImage}
            alt="Gallery Preview"
            className="max-w-full max-h-[90vh] object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
};

export default GallerySection;
